class collectionCarousel{
  constructor() {
    this.mySiema = null;
    this.interval = null;

    // Add click event to all collection buttons
    document.querySelectorAll('.collection-switch').forEach(btn => {
      btn.addEventListener('click', event => {
        this.getCollection(event.target)
      });
    });
  }

  initCarousel()
  {
    // Get number of slider items to determine loop setting and prevent breaking carousel
    const slider = document.querySelector('.collection-carousel_wrapper');
    const items = slider.querySelectorAll('.card-wrapper').length;
    
    // Initialize siema carousel
    this.mySiema = new Siema({
      selector: '.collection-carousel_wrapper',
      duration: 800,
      /*easing: 'ease-out',*/
      draggable: false,
      perPage: 1,
      startIndex: 0,
      loop: items > 3 ? true : false,
      perPage: {
        768: 2,
        1024: 4,
      }
    });

    // Set interval for sliding speed
    this.interval = setInterval(() => this.mySiema.next(), 2000);
  }

  destroyCarousel()
  {
    // Siema destroy
    this.mySiema.destroy(true);

    // Clear interval
    clearInterval(this.interval);
  }

  getCollection(e){

    // Destroy carousel and reset to plain html
    this.destroyCarousel();

    // Hide current carousel wrapper
    var hide = document.querySelector("div.visible");
    hide.classList.remove("visible");
    hide.classList.remove("collection-carousel_wrapper");
    hide.classList.add("hidden");
    hide.nextElementSibling.classList.add("hidden");

    // And show the one matching with the data attribute
    var show = document.querySelector("div[data-collection-wrapper='"+ e.getAttribute('data-collection') +"']");
    show.classList.remove("hidden");
    show.classList.add("collection-carousel_wrapper");
    show.classList.add("visible");
    show.nextElementSibling.classList.remove("hidden");

    document.querySelector(".current").classList.remove("current");
    e.classList.add("current");

    // Init carousel again
    this.initCarousel();
  }
}

if(document.querySelectorAll(".collection-carousel_wrapper").length > 0)
{
  var carousel = new collectionCarousel();
  
  carousel.initCarousel();
}